import { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { Reveal } from "./Reveal";
import { safeGet } from "@/lib/api";

const Card = ({ r, i }) => (
  <Reveal delay={(i % 3) * 0.08} className={i === 0 ? "md:col-span-2" : ""}>
    <figure data-testid={`testimonial-${i}`} className="flex h-full flex-col justify-between border border-line bg-[#0b0b0b] p-8">
      <div>
        <div className="flex gap-1">{Array.from({ length: r.rating ?? 5 }).map((_, k) => <Star key={k} size={14} className="fill-white text-white" />)}</div>
        <blockquote className={`mt-6 leading-relaxed text-zinc-200 ${i === 0 ? "font-display text-2xl md:text-3xl" : "text-base"}`}>“{r.text}”</blockquote>
      </div>
      <figcaption className="mt-8 flex items-center gap-4">
        {r.photo_url ? <img src={r.photo_url} alt={r.name} className="h-11 w-11 rounded-full object-cover grayscale" />
          : <span className="font-display flex h-11 w-11 items-center justify-center rounded-full bg-[#1a1a1a] text-white">{r.name?.[0]}</span>}
        <span>
          <span className="block text-sm font-medium text-white">{r.name}</span>
          <span className="block text-xs text-zinc-400">{r.role || `Verified ${r.product} buyer`}</span>
        </span>
      </figcaption>
    </figure>
  </Reveal>
);

export const Testimonials = () => {
  const [reviews, setReviews] = useState([]);
  useEffect(() => {
    safeGet("/reviews", []).then((d) => setReviews(Array.isArray(d) ? d : []));
  }, []);
  if (!reviews.length) return null;
  return (
    <section data-testid="testimonials-section" className="mx-auto max-w-7xl px-6 py-24 md:px-12 md:py-32">
      <p className="eyebrow">Real buyers</p>
      <h2 className="font-display mt-5 max-w-2xl text-4xl font-medium tracking-tight text-white md:text-5xl">
        In their own words.
      </h2>
      <div className="mt-14 grid gap-6 md:grid-cols-3">
        {reviews.slice(0, 8).map((r, i) => <Card key={r.id} r={r} i={i} />)}
      </div>
    </section>
  );
};
